// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1YWmC","alertIcon":"ConfirmModal_alertIcon__2kUbO"};